import { PalmettoButton, PalmettoIcon } from '@palmetto/dsm-components';
import { useCallback, useMemo } from 'react';
import { useFieldArray, Control, UseFormSetValue } from 'react-hook-form';

import { DialogFormValues } from './checklistItemInputOptions';
import { InputOptionRow } from './InputOptionRow';

export interface InputOptionsEditorProps {
  inputIndex: number;
  control: Control<DialogFormValues>;
  setValue: UseFormSetValue<DialogFormValues>;
}

export const InputOptionsEditor = ({ inputIndex, control, setValue }: InputOptionsEditorProps) => {
  const {
    fields: optionFields,
    append: appendOption,
    remove: removeOption,
  } = useFieldArray({
    control,
    name: `inputs.${inputIndex}.options`,
  });

  const handleAddOption = useCallback(() => {
    appendOption({ label: '', value: '', decisionType: undefined });
  }, [appendOption]);

  const addOptionIcon = useMemo(() => <PalmettoIcon name="add" size="xs" />, []);

  return (
    <div>
      <div className="mb-1 text-sm font-bold">Options</div>
      {optionFields.map((optionField, optionIndex) => (
        <InputOptionRow
          key={optionField.id}
          inputIndex={inputIndex}
          optionIndex={optionIndex}
          control={control}
          setValue={setValue}
          removeOption={removeOption}
        />
      ))}
      <PalmettoButton
        type="button"
        emphasis="tertiary"
        size="small"
        layout="hug"
        onClick={handleAddOption}
        leadingIcon={addOptionIcon}
      >
        Option
      </PalmettoButton>
    </div>
  );
};
